<template>
  <GmapMap ref="gmaps" :center="center" :zoom="zoom" map-type-id="terrain" style="height: 750px">
    <GmapCircle
      v-for="pin in dc"
      :key="pin.id+'_area'"
      :center="pin.position"
      :radius="pin.radius"
      :visible="true"
      :icon="icon"
      :options="{fillColor:'#FFDD00',fillOpacity:0.1}"
    ></GmapCircle>

    <GmapMarker
      :key="index+'_dc'"
      v-for="(m, index) in dc"
      :position="m.position"
      :title="m.title"
      :clickable="true"
      :icon="icon"
      @click="center= m.position; infoWindowsDC(m,index+'_dc')"
      style="color: #000;"
    />

    <GmapMarker
      :key="index+'_store'"
      v-for="(m, index) in stores"
      :position="m.position"
      :title="m.title"
      :clickable="true"
      :icon="markerIcon[m.type].icon"
      @click="center= m.position; infoWindowsStore(m, index+'_store'); dc_code = m.dc_code"
      style="color: #000;"
    />

    <GmapInfoWindow
      :options="infoOptions"
      :position="infoWindowPos"
      :opened="infoWinOpen"
      @closeclick="infoWinOpen=false"
    >
      <div v-if="infoContent !== ''" v-html="infoContent"></div>
      <div v-if="storeContent !== ''">
        <b-form id="storeForm">
          <b-col>
            <p class="text-center">
              <strong style="font-size:15px">Mapping toko dengan DC</strong>
            </p>
          </b-col>

          <b-col>
            <b-form-group label-for="name" label="Nama Toko">
              <b-form-input
                id="name"
                type="text"
                v-model="storeContent"
                readonly
                required
                placeholder="Nama lengkap"
              ></b-form-input>
              <b-form-invalid-feedback>Nama lengkap harus di isi.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label-for="dc_code" label="Mitra DC">
              <b-form-select id="dc_code" :options="listMitra" v-model="dc_code" required>
                <template slot="first">
                  <option :value="null" disabled>-- Harap pilih salah satu --</option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>DC harus di pilih.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-form>
        <b-button
          v-if="buttonCreateGroup"
          @click="submitButton"
          size="sm"
          variant="github"
          class="pull-right mr-1 btn-brand"
        >
          <span>{{labelButton}}</span>
        </b-button>

        <b-button
          v-if="!buttonCreateGroup"
          @click="removeGroup()"
          size="sm"
          variant="html5"
          class="mr-1 btn-brand"
        >
          <i class="fa fa-github"></i>
          <span>Ungroup</span>
        </b-button>
      </div>
    </GmapInfoWindow>
  </GmapMap>
</template>

<!--<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDd8QDU7e4Fk5UDGVMHU4r4LH675QaPIOk&callback=initMaps"></script>-->
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import interfaces from "@/templates/_interfaces.js";

export default {
  name: "GoogleMap",
  props: {
    dataDc: {
      type: [Array, Function],
      default: () => []
    },
    dataStore: {
      type: [Array, Function],
      default: () => []
    },
    labelButton: {
      type: String,
      default: "Make a group"
    }
    // listMitraDc: {
    //   type: [Array, Function],
    //   default: () => []
    // }
  },
  data() {
    return {
      radius: 30000,
      listMitra: [],
      markers: [],
      center: { lat: -6.597147, lng: 106.806038 },
      map: null,
      dc_code: null,
      dc_id: null,
      icon: {
        path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
        scale: 3
      },
      markerIcon: {
        red: {
          icon: "/icon-map/red-i-75.png"
        },
        blue: {
          icon: "/icon-map/blue-i-75.png"
        }
      },
      infoContent: "",
      storeContent: "",
      buttonCreateGroup: false,
      zoom: 10,
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      storeForm: interfaces.indomaret
    };
  },
  validations: {
    storeForm: {
      dc_code: { required },
      name: {},
      store_code: {},
      address: {},
      lat: {},
      long: {}
    }
  },
  computed: {
    dc: function() {
      const dc = this.dataDc;
      return this.dataDc;
    },
    stores: function() {
      const stores = this.dataStore;
      return this.dataStore;
    }
  },
  methods: {
    init: function() {
      this.axios
        .get("dropdown/mitra/")
        .then(response => {
          this.listMitra = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    infoWindowsDC: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getinfoWindowsDCContent(marker);
      this.storeContent = "";
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    infoWindowsStore: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.storeContent = this.getinfoWindowsStoresContent(marker);
      this.dc_id = marker.id;
      this.infoContent = "";
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getinfoWindowsDCContent: function(marker) {
      this.buttonCreateGroup = true;
      return `<div class="content">
                  ${marker.dc_code} - ${marker.title}
               </div>`;
    },
    getinfoWindowsStoresContent: function(marker) {
      this.buttonCreateGroup = true;
      return marker.title;
    },
    submitButton: function() {
      this.$emit("submitButton", this.dc_code, this.dc_id);
      this.infoWinOpen = false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>